export const getInitialFormValues = ({ items, feesOptions, feeProviderOptions, cureBaseline }) => ({
  set_1: items.map((fee, index) => {
    const formattedFee = {
      ...fee,
      index,
      feeTypeName: fee.feeName,
      feeTypeId: feesOptions.find(i => i.value === fee.feeTypeId),
      feeProviderId: feeProviderOptions.find(i => i.value === fee.feeProviderId),
    };

    return {
      ...formattedFee,
      initialFee: formattedFee,
      cureBaseline: cureBaseline?.[fee.feeTypeId],
    };
  }),
  // set_2: ...
  // set_3: ...
});
